import React, { useRef } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { IoCloseOutline } from "react-icons/io5";


function Modal({ onClose, title, description, isErrModal }) {
    const modalRef = useRef();
    const router = useRouter();

    const handleOkClick = () => {
        onClose();
        router.push('/');
    };

    return (
        <div className="fixed pt-20 inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" ref={modalRef}>
            <div className="flex flex-col justify-center items-center gap-6 md:gap-10 rounded-2xl border-2 bg-slate-50 w-full max-w-[90%] md:max-w-[600px] p-4 md:p-6">
                <div className='content w-full md:w-[95%] flex flex-row justify-between font-medium text-center gap-3 md:gap-4'>
                    <h2 className={`text-2xl md:text-4xl font-bold ${isErrModal ? 'text-red-400' : 'text-[#23C25D]'}`}>
                        {title}
                    </h2>
                    <span className='border h-fit border-black rounded-sm shadow-md p-1 mt-1'>
                        <IoCloseOutline className='text-2xl text-black' onClick={onClose} />
                    </span>
                </div>
                <div className="w-[180px] md:w-[250px] h-auto">
                    <Image
                        src="/form-success-image.png"
                        alt='no-image-found'
                        width={250}
                        height={250}
                        className='mix-blend-multiply filter brightness-100 contrast-125 w-full h-auto'
                    />
                </div>
                <div className='text-center px-4 md:px-20'>
                    <p className="text-sm md:text-base font-semibold text-black">
                        {description}
                    </p>
                </div>
                <div className='flex justify-center mt-2'>
                    <button
                        className='bg-white text-base md:text-xl font-medium rounded-md py-1.5 md:py-2 px-8 md:px-12 border border-black hover:border-transparent hover:bg-blue-500 hover:text-white transition-all'
                        onClick={handleOkClick}
                    >
                        Explore More
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Modal;